export default __webpack_public_path__ + "static/media/Cloak of Munin.96fe0e9b.jpg";